"use strict";

exports.__esModule = true;
exports.timeSeriesAxis = void 0;
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
var _d3Scale = require("d3-scale");
var _modernChartLayout = require("../../modernChartLayout");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Axis to be passed into ReCharts has to XAxis and can not be wrapped by any wrapper components.
 * Hence TimeSeriesAxis can not be a component.
 *  Recharts - XAxis is a empty component which returns null with a few default props
 *  Recharts wrapper uses these default props to render the xAxis rather then the xAxis rendering its view.
 *  Refer : https://github.com/recharts/recharts/blob/master/src/cartesian/XAxis.tsx#L28
 */
var timeSeriesAxis = exports.timeSeriesAxis = function timeSeriesAxis(_ref) {
  var _ref$hide = _ref.hide,
    hide = _ref$hide === void 0 ? false : _ref$hide,
    _ref$domain = _ref.domain,
    domain = _ref$domain === void 0 ? ["dataMin", "dataMax"] : _ref$domain,
    theme = _ref.theme;
  var scale = (0, _d3Scale.scaleUtc)().domain(domain);
  var ticks = scale.ticks(10).map(function (v) {
    return v.valueOf();
  });
  var formatter = scale.tickFormat();
  return /*#__PURE__*/_react["default"].createElement(_recharts.XAxis, _extends({
    name: "Time",
    type: "number",
    allowDuplicatedCategory: false,
    dataKey: "key",
    tick: theme.uiModern ? {
      fontSize: 10.5,
      fill: theme.ChartAxisTextColor,
      fontFamily: theme.ChartFontFamilyMono
    } : {
      fontSize: theme.fontSizeXS,
      fill: theme.color
    },
    axisLine: !theme.uiModern,
    tickLine: !theme.uiModern,
    tickFormatter: function tickFormatter(timestamp) {
      return formatter(new Date(timestamp));
    },
    ticks: ticks,
    domain: domain || ["dataMin", "dataMax"],
    hide: hide
  }, (0, _modernChartLayout.modernXAxisProps)(theme)));
};